<template>
<div>
</div>
</template>
<script>
export default {
  name: 'Noting',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/system/nothing.vue